{
  "name": "smocipa-portaria",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration development",
    "build": "ng build --verbose",
    "build-dev": "ng build --configuration development",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.0",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@angular/service-worker": "^20.3.0",
    "@fortawesome/fontawesome-free": "^5.15.1",
    "@ng-select/ng-select": "^20.0.0",
    "@syncfusion/ej2-angular-base": "^33.1.44",
    "@syncfusion/ej2-angular-buttons": "^33.1.44",
    "@syncfusion/ej2-angular-calendars": "^33.1.44",
    "@syncfusion/ej2-angular-dropdowns": "^33.1.44",
    "@syncfusion/ej2-angular-grids": "^33.1.45",
    "@syncfusion/ej2-angular-inputs": "^33.1.44",
    "@syncfusion/ej2-angular-layouts": "^33.1.44",
    "@syncfusion/ej2-angular-lists": "^33.1.44",
    "@syncfusion/ej2-angular-navigations": "^33.1.45",
    "@syncfusion/ej2-angular-notifications": "^33.1.44",
    "@syncfusion/ej2-angular-popups": "^33.1.44",
    "@syncfusion/ej2-angular-splitbuttons": "^33.1.44",
    "@syncfusion/ej2-base": "^33.1.45",
    "@syncfusion/ej2-icons": "^33.1.45",
    "@tsparticles/angular": "^3.0.0",
    "@tsparticles/engine": "^3.9.1",
    "@tsparticles/slim": "^3.9.1",
    "@types/jwt-decode": "^2.2.1",
    "bootstrap": "^4.5.3",
    "bootstrap3": "^3.3.5",
    "ionicons": "^4.6.3",
    "jquery": "^3.5.1",
    "jwt-decode": "^2.2.0",
    "rxjs": "~7.8.0",
    "select2": "^4.0.13",
    "tslib": "^2.3.0",
    "video.js": "^8.23.4",
    "videojs-markers": "^1.0.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.24",
    "@angular/cli": "^20.3.24",
    "@angular/compiler-cli": "^20.3.0",
    "@types/jasmine": "~5.1.0",
    "@types/jquery": "^3.5.34",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "less": "^4.2.0",
    "typescript": "~5.9.2"
  }
}
